<template>
	<div>
		<div class="subheader position-relative">
			<h1 class="text-center text-white position-relative">
				{{ $t("navbar.field") }}
			</h1>
		</div>
	    <div class="bg-vanilla text-brown">
			<div class="container p-md-5 py-3">
				<div class="row">
					<div class="col-md-7 col-12">
						<p>{{ $t("field.intro_zero") }}<p>
						<p>{{ $t("field.intro_first") }}<p>
						<p>{{ $t("field.intro_second") }}</p>
						<ul>
							<li>{{ $t("field.li_0") }}</li>
							<li>{{ $t("field.li_1") }}</li>
							<li>{{ $t("field.li_2") }}</li>
							<!--<li>{{ $t("field.li_3") }}</li>-->
							<li>{{ $t("field.li_4") }}</li>
							<li>{{ $t("field.li_5") }}</li>
							<li>{{ $t("field.li_6") }}</li>
						</ul>
						<p>{{ $t("field.intro_third") }}
							<a class="text-brown text-decoration-none" href="contact">{{ $t("field.link") }}</a>
						</p>
						<p>{{ $t("field.last") }}</p>
					</div>
					<div class="col-md-5 col-12">
						<div id="carouselExampleIndicators" class="carousel slide field" data-ride="carousel">
						  	<div class="carousel-inner">
						    	<div class="carousel-item active">
						      		<img src="../assets/img/field0.jpg" class="img-fluid" alt="..." draggable="false">
						    	</div>
						    	<div class="carousel-item">
						      		<img src="../assets/img/field1.jpg" class="img-fluid" alt="..." draggable="false">
						    	</div>
						    	<div class="carousel-item">
						      		<img src="../assets/img/new2.jpg" class="img-fluid" alt="..." draggable="false">
						    	</div>
						  	</div>
						  	<a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
						    	<span class="carousel-control-prev-icon" aria-hidden="true"></span>
						    	<span class="sr-only">Previous</span>
						  	</a>
						  	<a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
						    	<span class="carousel-control-next-icon" aria-hidden="true"></span>
						    	<span class="sr-only">Next</span>
						  	</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";

    export default {
    	data: function(){
    		return {
    			lang: ""
    		}
    	},
    	created: function(){
    		this.lang = this.$i18n.locale;
    	},
    	mounted: function(){
    		var self = this;
    		Bus.$on("lang", (lang) => {
				if(lang === "hu"){
					self.lang = "hu";
				}else{
					self.lang = "en";
				}
			});
    	},
    	watch: {
    		lang: function(){
    			if(this.lang === "hu"){
					history.pushState('', "Íjászpálya", "https://ijaszat.eu/ijaszpalya");
				}else{
					history.pushState('', "Archery range", "https://ijaszat.eu/archery-range");
				}
    		}
    	},
    	metaInfo() {
		    return {
				titleTemplate: chunk => (
					this.lang === 'hu'
                    ? 'Csodaszarvas Íjászbarlang - Pálya'
                    : 'Csodaszarvas Íjászbarlang - Field'
				),
				meta: [
    			{
    				vmid: 'description',
			        name: 'description',
			        content: this.lang === 'hu' ? 'Fedett pályánkon három 18 méteres és két 21 méteres pálya várja telefonos egyeztetés után az íjászkodni vágyókat.' : 'Our field has three 18 and three 21 metres long. Our olympic durafoam targets and the 18-21 metres long shooting ranges make the shooting suitable for them as well.',
    			},
    			{
    				vmid: 'og:description',
			        name: 'og:description',
			        content: this.lang === 'hu' ? 'Fedett pályánkon három 18 méteres és két 21 méteres pálya várja telefonos egyeztetés után az íjászkodni vágyókat.' : 'Our field has three 18 and three 21 metres long. Our olympic durafoam targets and the 18-21 metres long shooting ranges make the shooting suitable for them as well.',
    			},
    			{
    				vmid: 'og:title',
    				property: 'og:title',
        			content: this.lang === 'hu' ? 'Csodaszarvas Íjászbarlang - Pálya' : 'Csodaszarvas Íjászbarlang - Field',
    			}
    		]
			};
		}
    };
</script>


// WEBPACK FOOTER //
// src/components/Field.vue